var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.936 21.125H5.064a1.442 1.442 0 01-1.383-1.136l-2.138-9a1.484 1.484 0 011.383-1.864h18.148a1.484 1.484 0 011.383 1.864l-2.138 9a1.442 1.442 0 01-1.383 1.136v0zM4.5 9.125L9 3.875M19.5 9.125L15 3.875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var MemoSvgCart = /*#__PURE__*/React.memo(SvgCart);
export default MemoSvgCart;